module.exports = __webpack_public_path__ + "img/icon-close.94f1e986.svg";